<template>
  <div class="wrapp">
    <div class="row">
      <div class="col-12">
        <h2>Lista de Usuários</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form class="form-inline">
          <input
            type="text"
            v-model="search"
            class="form-control"
            placeholder="Buscar na lista por..."
            style="height:38px"
            @keyup="searchingUser"
          />
          <button
            type="button"
            @click="resetSearch"
            class="btn btn-primary ml-2"
          >
            Limpar
          </button>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <b-table
          striped
          hover
          :fields="fields"
          :items="users"
          :busy="loading"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                type="grow"
                class="align-middle"
              ></b-spinner>
            </div>
          </template>
          <!-- Concessionários -->
          <template v-slot:cell(dealers)="row">
            <div class="dealers">
              <div class="chips-columns">
                <div
                  v-for="(dealer, i) in row.item.dealers"
                  :key="i"
                >
                  <div
                    ref="chip"
                    class="chip"
                  >
                    {{ dealer.name }}
                    <span
                      @click="removeUserDealer(row.item.id, dealer.id)"
                      class="closebtn"
                    >&times;</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- Data de Cadastro -->
          <template v-slot:cell(createdAt)="row">
            {{ formatDate(row.item.createdAt) }}
          </template>
          <!-- Data de Cadastro -->
          <template v-slot:cell(last_access)="row">
            {{ formatDate(row.item.last_access) }}
          </template>
          <!-- Status -->
          <template v-slot:cell(active)="row">
            <span v-if="row.item.active === 'pending'">Aguardando</span>
            <span v-else-if="row.item.active === 'active'">Ativo</span>
            <span v-else>Inativo</span>
          </template>
          <!-- Aprovação -->
          <template v-slot:cell(action)="row">
            <div class="btn-actions">
              <a
                class="btn btn-secondary btn-sm"
                @click="editaUsuario(row.item.id)"
              >
                <i class="fas fa-pen"></i>
              </a>
              <button
                class="btn btn-danger btn-sm"
                @click="deleteUser(row.item.id)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </template>
        </b-table>
        <div class="pagination-users">
          <paginate
            v-model="page"
            :page-count="Math.ceil(this.total / this.limit)"
            :click-handler="changePage"
            :prevText="'‹'"
            :nextText="'›'"
            :activeClass="'active'"
            :containerClass="'pagination b-pagination'"
            :pageClass="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { lightFormat } from 'date-fns';

export default {
  data: () => ({
    userAuth: null,
    search: null,
    typingTimer: null,
    doneTypingInterval: 500,
    page: 1,
    limit: 50,
    loading: true,
    fields: [
      { key: 'name', label: 'Nome' },
      { key: 'email', label: 'E-mail' },
      { key: 'celphone', label: 'Telefone' },
      { key: 'dealers', label: 'Concessionários' },
      { key: 'createdAt', label: 'Data de Cadastro' },
      { key: 'last_access', label: 'Último Acesso' },
      { key: 'active', label: 'Status' },
      { key: 'action', label: 'Ação' },
    ],
    items: [],
  }),

  computed: {
    ...mapState('users', ['users', 'total']),
  },

  methods: {
    ...mapActions('users', ['getUsers', 'approveUser', 'removeUser']),
    ...mapActions('dealers', ['removeDealer']),

    async removeUserDealer(userId, dealerId) {
      try {
        await this.removeDealer({
          token: this.userAuth.token,
          userId,
          dealerId,
        });

        this.$swal('Sucesso!', 'Dealer desassociado ao usuário.', 'success');

        this.loading = true;

        await this.getUsers({
          token: this.userAuth.token,
          page: this.page,
          limit: this.limit,
        });

        this.loading = false;
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },

    async changePage() {
      this.loading = true;

      await this.getUsers({
        token: this.userAuth.token,
        page: this.page,
        limit: this.limit,
      });

      this.loading = false;
    },

    formatDate(date) {
      if (date) {
        return lightFormat(new Date(date), 'dd/MM/yyyy HH:mm');
      }
      return '-';
    },
    editaUsuario(id) {
      // eslint-disable-next-line
      this.$router.push(`/users/${id}`).catch(err => {});
    },
    deleteUser(id) {
      this.removeUser({
        id,
        token: this.userAuth.token,
      }).then(async () => {
        this.$swal('Sucesso!', 'Usuário deletado com sucesso.', 'success');
        this.loading = true;

        await this.getUsers({
          token: this.userAuth.token,
          page: this.page,
          limit: this.limit,
        });

        this.loading = false;
      });
    },
    async resetSearch() {
      this.search = null;
      this.loading = true;

      await this.getUsers({
        token: this.userAuth.token,
        page: this.page,
        limit: this.limit,
      });

      this.loading = false;
    },
    async Search() {
      this.loading = true;

      await this.getUsers({
        token: this.userAuth.token,
        page: this.page,
        limit: this.limit,
        filter: this.search,
      });

      this.loading = false;
    },
    searchingUser() {
      if (
        this.search !== ''
        && this.search !== null
        && this.search.length > 2
      ) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.Search, this.doneTypingInterval);
      }
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));

    await this.getUsers({
      token: this.userAuth.token,
      page: this.page,
      limit: this.limit,
    });

    this.items = this.users;

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.wrapp {
  padding: 16px;
  max-height: calc(100vh - 72px);
  background-color: #f1f1f1;
  overflow: auto;
}

.chip {
  padding: 3px 15px;
  font-size: 10px;
  border-radius: 20px;
  float: left;
  margin: 2px;
  background-color: #303030;
  color: #fff;
  display: flex;
  align-items: center;
}

.dealers {
//  max-height: 120px;
  overflow: auto;
}

// .chips-columns {
//  max-height: 200px;
// }

.closebtn {
  padding-left: 10px;
  color: #fff;
  font-weight: bold;
  float: right;
  font-size: 15px;
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
</style>

<style>
.pagination-users a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #303030;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.pagination-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #303030;
  border-color: #303030;
}

.pagination-users a {
  outline: none;
}
.btn-actions {
  display: flex;
}
</style>
